export default __webpack_public_path__ + "static/media/plain-sticker-x.9d0674a6.png";